/**
 * Cancellation re-engagement message templates.
 *
 * Used by both the NotificationBell `WhatsApp con propuesta` dialog AND
 * the Stats → Cancelaciones list to offer alternatives to the patient
 * who cancelled. NO Meta template approval is needed — the doctor opens
 * `wa.me` and sends the message manually from her own WhatsApp session.
 */

export const REENGAGEMENT_TEMPLATES = {
  'Conflicto de horario': (n) => `Hola ${n}, vi que cancelaste por motivos de horario. Tengo huecos los sábados por la mañana y también puedo verte por teleconsulta. ¿Te encajaría alguno?`,
  'Económico': (n) => `Hola ${n}, vi tu cancelación. Si lo prefieres puedo ofrecerte teleconsulta a menor coste o financiación en cuotas. ¿Hablamos?`,
  'Distancia / desplazam.': (n) => `Hola ${n}, vi que la consulta te queda lejos. Puedo atenderte por teleconsulta sin necesidad de desplazarte. ¿Te interesa?`,
  'Motivo de salud': (n) => `Hola ${n}, espero que todo se resuelva pronto. Cuando estés disponible, contáctame y te reservo nuevo hueco con prioridad.`,
  'Familia / cuidado': (n) => `Hola ${n}, entiendo que la familia es lo primero. Cuando estés disponible, escríbeme y te reservo un nuevo hueco que te encaje.`,
  'Cambio de planes': (n) => `Hola ${n}, vi que cancelaste tu cita. Tengo nuevos huecos disponibles las próximas semanas. ¿Quieres que te proponga alternativas?`,
  'Otro profesional': (n) => `Hola ${n}, vi tu cancelación. Si más adelante necesitas una segunda opinión o seguimiento, no dudes en contactarme.`,
  'Resuelto / sin necesidad': (n) => `Hola ${n}, me alegro de que esté mejor. Si en algún momento necesitas revisión o seguimiento, estoy a su disposición.`,
  'Insatisfacción': (n) => `Hola ${n}, lamento que no haya sido la mejor experiencia. Si quieres hablar y revisarlo, escríbeme cuando puedas — me gustaría saber qué podemos mejorar.`,
  'Sin motivo indicado': (n) => `Hola ${n}, vi que cancelaste tu cita. Si necesitas reagendar o cambiar a teleconsulta, escríbeme cuando quieras y te propongo alternativas.`,
  'Otro': (n) => `Hola ${n}, lamento que hayas cancelado. Si te apetece reagendar o necesitas algo, escríbeme cuando quieras.`,
};

const KEYWORDS = [
  ['Cambio de planes',       ['viaje','vacacion','vacaci','imprevisto','surgio','surgió','planes','boda','fiesta','reunion familiar']],
  ['Conflicto de horario',   ['trabajo','horario','no puedo a esa','no me viene','incompatib','reunion','junta','examen']],
  ['Motivo de salud',        ['enferm','salud','indispuest','fiebre','covid','gripe','operaci','hospital','ingreso']],
  ['Familia / cuidado',      ['familia','hijo','hija','madre','padre','niñ','abuel','cuidar']],
  ['Económico',              ['precio','coste','económic','economic','dinero','caro','presupuesto','no me lo puedo permitir']],
  ['Otro profesional',       ['otra consulta','otro médico','otro medico','segunda opini','ya me ha visto']],
  ['Distancia / desplazam.', ['lejos','distancia','transporte','parking','aparcar','tráfico','desplazar']],
  ['Resuelto / sin necesidad', ['ya no necesito','ha mejorado','se ha resuelto','no hace falta','está mejor','esta mejor']],
  ['Insatisfacción',         ['disgusto','queja','mala atenci','no me gust','decepcion']],
];

export const classifyReason = (reason) => {
  if (!reason || !reason.trim()) return 'Sin motivo indicado';
  const lowered = reason.toLowerCase();
  for (const [label, kws] of KEYWORDS) {
    for (const kw of kws) if (lowered.includes(kw)) return label;
  }
  return 'Otro';
};

export const firstName = (full) => (full || '').split(/\s+/)[0] || 'paciente';

export const buildWaUrl = (phone, message) => {
  const cleanPhone = (phone || '').replace(/[^\d+]/g, '').replace(/^\+/, '');
  return `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`;
};
